const PayWithLOCQPayStatus = {
  Success: "success",
  Voided: "voided",
};

export default PayWithLOCQPayStatus;
